import { DROP_TYPE_PATH } from "@pathwright/web/src/modules/path/constants"
import classnames from "classnames"
import ConnectStores from "lib/core/store/components/ConnectStores"
import { DESIGN, LEARN } from "path/constants"
import React from "react"
import { Draggable } from "react-beautiful-dnd"
import { withIsDragging } from "../../DragDropPathItems"
import PathGroup from "./PathGroup"
import "./PathGroupContainer.css"
import PathGroupEditor from "./PathGroupEditor"

const PathGroupContainerDraggable = function (props) {
  const { mode, item, standaloneLesson } = props

  if (mode === DESIGN && !standaloneLesson) {
    return (
      <Draggable
        type={DROP_TYPE_PATH}
        draggableId={item.id + ""}
        index={item.order - 1}
      >
        {(provided, snapshot) => {
          // Border prevents margin collapsing. Margin works better than padding.
          return (
            <div>
              <div ref={provided.innerRef} {...provided.draggableProps}>
                <div style={{ border: "1px solid transparent" }}>
                  <div style={{ margin: "19px 0" }}>
                    <ConnectedPathGroupContainer
                      {...props}
                      dragHandleProps={provided.dragHandleProps}
                      isDragging={snapshot.isDragging}
                    />
                  </div>
                </div>
              </div>
              {provided.placeholder}
            </div>
          )
        }}
      </Draggable>
    )
  } else {
    return <ConnectedPathGroupContainer {...Object.assign({}, props)} />
  }
}

/*
PathGroupContainer handles all shared state between group modes (learn, design, teach)
*/

class PathGroupContainer extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.isDragging !== this.props.isDragging) {
      return true
    }
    if (nextProps.pathListIsDragging) {
      return false
    }
    if (this.props.mode === DESIGN) {
      return true
    } // defer to PathGroupEditor
    if (nextProps.isNext !== this.props.isNext) {
      return true
    }
    if (nextProps.isInactive !== this.props.isInactive) {
      return true
    }
    if (nextProps.analytics !== this.props.analytics) {
      return true
    }
    if (nextProps.mode !== this.props.mode) {
      return true
    }
    if (nextProps.expanded !== this.props.expanded) {
      return true
    }
    if (nextProps.stepsExpanded !== this.props.stepsExpanded) {
      return true
    }
    if (JSON.stringify(nextProps.item) !== JSON.stringify(this.props.item)) {
      return true
    }
    if (
      JSON.stringify(nextProps.item.items) !==
      JSON.stringify(this.props.item.items)
    ) {
      return true
    }
    return false
  }

  render() {
    const {
      item,
      mode,
      isNext,
      isEditing,
      stepCount,
      expanded,
      nextStepURL,
      stepsExpanded,
      toggleGroup,
      toggleGroupSteps,
      analytics,
      stats,
      index,
      startsDate,
      dueDate,
      isInactive,
      isDragging,
      dragHandleProps
    } = this.props

    const toggleHandler = function (e) {
      e.preventDefault()
      return toggleGroup(item.sync_source_id)
    }

    const passProps = {
      isNext,
      expanded,
      stepsExpanded,
      stepCount,
      mode,
      item,
      stats,
      analytics,
      isInactive,
      nextStepURL,
      dragHandleProps,
      handleToggleExpand: toggleHandler,
      handleToggleExpandSteps() {
        return toggleGroupSteps(item.sync_source_id)
      }
    }

    const classNames = classnames(
      "PathGroupContainer",
      `PathGroupContainer--index-${item.order}`,
      { "PathGroupContainer--dragging": isDragging }
    )

    return (
      <div className={classNames}>
        {isEditing ? (
          <PathGroupEditor
            {...Object.assign({}, passProps, {
              index: index
            })}
          />
        ) : (
          <PathGroup
            {...Object.assign({}, passProps, {
              startsDate: startsDate,
              dueDate: dueDate
            })}
          />
        )}
      </div>
    )
  }
}

PathGroupContainer.displayName = "PathGroupContainer"

const mapStateToProps = function (state, ownProps) {
  const { next_group, mode, path } = state.pathStore.state
  const { item } = ownProps
  const isNext = next_group === item.id
  const isEditing = mode === DESIGN
  const stepCount = (item.items != null ? item.items.length : undefined) || 0
  const nextStepURL = __guard__(
    state.pathStore.request.getNextStepForGroup(item.id),
    (x) => x.get("url")
  )
  const { toggleGroup, toggleGroupSteps } = state.pathStore.action

  const analytics = state.pathAnalyticsStore.request.getAnalyticsForItem(
    item.sync_source_id
  )
  const stats = state.pathStore.request.getGroupStats(item.id)
  const startsDate = state.pathStore.request.getStartsDateForGroup(item.id)
  const dueDate = state.pathStore.request.getDueDateForGroup(item.id)

  // expanded state
  const expanded = state.pathStore.request.isGroupExpanded(item.sync_source_id)
  const stepsExpanded = expanded // state.pathStore.request.areGroupStepsExpanded(item.id)

  const isInactive = !isNext && !expanded && mode === LEARN

  return _.assign(
    {},
    {
      isNext,
      isEditing,
      stepCount,
      expanded,
      stepsExpanded,
      toggleGroup,
      nextStepURL,
      toggleGroupSteps,
      path,
      mode,
      analytics,
      stats,
      startsDate,
      dueDate,
      isInactive
    },
    ownProps
  )
}

const stores = [
  {
    store: "path",
    watch: [
      "path",
      "expanded_groups",
      "next_group",
      "expanded_group_steps",
      "mode"
    ]
  },
  { store: "pathAnalytics", watch: ["item_analytics"] }
]

var ConnectedPathGroupContainer = ConnectStores(
  PathGroupContainer,
  stores,
  {},
  mapStateToProps
)

export default withIsDragging(PathGroupContainerDraggable)

function __guard__(value, transform) {
  return typeof value !== "undefined" && value !== null
    ? transform(value)
    : undefined
}
